/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLegalEntityPaymentMethodRequest
 */
export interface UpdateLegalEntityPaymentMethodRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateLegalEntityPaymentMethodRequest
     */
    paymentMethod: UpdateLegalEntityPaymentMethodRequestPaymentMethodEnum;
}


/**
 * @export
 */
export const UpdateLegalEntityPaymentMethodRequestPaymentMethodEnum = {
    Card: 'card',
    Sepa: 'sepa'
} as const;
export type UpdateLegalEntityPaymentMethodRequestPaymentMethodEnum = typeof UpdateLegalEntityPaymentMethodRequestPaymentMethodEnum[keyof typeof UpdateLegalEntityPaymentMethodRequestPaymentMethodEnum];


/**
 * Check if a given object implements the UpdateLegalEntityPaymentMethodRequest interface.
 */
export function instanceOfUpdateLegalEntityPaymentMethodRequest(value: object): value is UpdateLegalEntityPaymentMethodRequest {
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    return true;
}

export function UpdateLegalEntityPaymentMethodRequestFromJSON(json: any): UpdateLegalEntityPaymentMethodRequest {
    return UpdateLegalEntityPaymentMethodRequestFromJSONTyped(json, false);
}

export function UpdateLegalEntityPaymentMethodRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLegalEntityPaymentMethodRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethod': json['paymentMethod'],
    };
}

export function UpdateLegalEntityPaymentMethodRequestToJSON(json: any): UpdateLegalEntityPaymentMethodRequest {
    return UpdateLegalEntityPaymentMethodRequestToJSONTyped(json, false);
}

export function UpdateLegalEntityPaymentMethodRequestToJSONTyped(value?: UpdateLegalEntityPaymentMethodRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentMethod': value['paymentMethod'],
    };
}

